import React, { ReactElement } from 'react';
import NewportApp from 'newport/NewportApp';
import StandaloneApp from './StandaloneApp';
import Services from 'store/Services';
import { AppMode } from './store/general/AppMode';
import { SupportVisualisationPopup } from 'widgets/supportVisualisation/SupportVisualisationPopup/SupportVisualisationPopup';
import { isSupportVisPopup } from 'widgets/supportVisualisation/SupportVisualisationPopup/popup';
import EmbeddedApp from 'embedded/EmbeddedApp';

export const NewportSingleWidgetUrl = 'widgets.html';
export const NewportLinkedPaletteUrl = 'widgetscfg.html';
export const EmbeddedWidgetUrl = 'embedded-widget.html';
export const EmbeddedDashboardUrl = 'embedded-dashboard.html';

export interface AppProps {
    services: Services;
}

export default function App(props: AppProps): ReactElement {
    const { services } = props;

    const { fileName, layout } = extractLocationDetails(window.location);

    if (isNewportSingleWidget(fileName)) {
        return (
            <NewportApp
                services={services}
                mode={AppMode.EMBEDDED_SINGLE_WIDGET}
                layout={layout}
            />
        );
    }

    if (isNewportLinkedPalette(fileName)) {
        return (
            <NewportApp
                services={services}
                mode={AppMode.EMBEDDED_DASHBOARD}
                layout={layout}
            />
        );
    }

    if (isEmbeddedSingleWidget(fileName)) {
        return (
            <EmbeddedApp
                services={services}
                mode={AppMode.EMBEDDED_SINGLE_WIDGET}
                layout={layout}
            />
        );
    }

    if (isEmbeddedDashboard(fileName)) {
        return (
            <EmbeddedApp
                services={services}
                mode={AppMode.EMBEDDED_DASHBOARD}
                layout={layout}
            />
        );
    }

    if (isSupportVisPopup()) {
        return <SupportVisualisationPopup services={services} />;
    }

    return <StandaloneApp services={services} layout={layout} />;
}

export function extractLocationDetails(location: Location): {
    fileName: string;
    layout: string;
} {
    const fileName = location.pathname.split(';')[0].toLowerCase();
    const layout = decodeURIComponent(
        location.hash.replace('#', '') || 'default'
    );

    return { fileName, layout };
}

export function isNewportSingleWidget(fileName: string) {
    return fileName.endsWith(NewportSingleWidgetUrl);
}

export function isNewportLinkedPalette(fileName: string) {
    return fileName.endsWith(NewportLinkedPaletteUrl);
}

export function isEmbeddedSingleWidget(fileName: string) {
    return fileName.endsWith(EmbeddedWidgetUrl);
}

export function isEmbeddedDashboard(fileName: string) {
    return fileName.endsWith(EmbeddedDashboardUrl);
}
